import { render, staticRenderFns } from "./MonthAllowancesPlanForm.vue?vue&type=template&id=72d85d55&scoped=true&"
import script from "./MonthAllowancesPlanForm.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d85d55",
  null
  
)

export default component.exports